import { NewChildContent, NewChildPopupBG, NewChildPopupText, NewChildPopupTitle, NewChildPopupWrapper, NoButton, PopupNewChildIcon, YesButton } from "../../atoms/FeedsPopup";
import { ModalCloseButton } from "../../atoms/StationModal/StationFeeds";
import warningIcon from "../../../images/warning.svg";
import { useTranslation } from "react-i18next";
import { gaEvent } from "../../../utilities/analytics";
import { useSelector } from "react-redux";

function SponsorNewChildPopup(props) {
    const { t } = useTranslation();
    const { persistItemsReducer } = useSelector((state) => state);
    const handleYesClick=()=>{
        // window.location.replace(props?.link);
        if(props?.TitleText?.includes(t("ChangePassword"))){
            gaEvent("UpdatePasswordPopupYesBtn",persistItemsReducer);
        }
        else if(props?.TitleText?.includes(t("AddNewChild"))){
            gaEvent("YesBtnAddNewChildPopup",persistItemsReducer);
        }
        else if(props?.TitleText?.includes(t("UpdatePhone"))){
            gaEvent("UpdatePhonePopupYesBtn",persistItemsReducer);
        }
        else if(props?.TitleText?.includes(t("UpdateEmail"))){
            gaEvent("UpdateEmailPopupYesBtn",persistItemsReducer);
        }
        else if(props?.TitleText?.includes(t("UpdateAddressTitle"))){
            gaEvent("UpdateAddressPopupYesBtn",persistItemsReducer);
        }
        else if(props?.TitleText?.includes(t("PayemntInfo"))){
            gaEvent("MyPaymentInfoPopupYesBtn",persistItemsReducer);
        }
        else if(props?.TitleText?.includes(t("TaxReceipts"))){
            gaEvent("TaxReceiptsPopupNotRightNowBtn",persistItemsReducer);
        }
        

        window.open(props?.link, "_blank", "noopener,noreferrer")
    }
    const { hostname } = new URL(props?.link);
    return ( 
        <>
            <NewChildPopupBG
                    show={props.show}
                    onClick={props?.closeBtnClick}
                    />
            <NewChildPopupWrapper>
                <ModalCloseButton onClick={props?.closeBtnClick}/>
                <NewChildPopupTitle>{props?.TitleText}</NewChildPopupTitle>
                <NewChildContent>
                    <PopupNewChildIcon><img src={warningIcon} alt="warningIcon"/></PopupNewChildIcon>
                    <NewChildPopupText policy={props?.policy} dangerouslySetInnerHTML={{__html: t("privacyBody",{link:`<a href=${props?.link} target="_blank">${hostname ? hostname : props?.link}</a>`})}}></NewChildPopupText>
                </NewChildContent>
                <YesButton
                    onClick={handleYesClick}>
                    <span>{t("Yes")}</span>
                </YesButton>
                <NoButton
                    onClick={props?.closeBtnClick}>
                    {t("NotRightNow")}
                </NoButton>
            </NewChildPopupWrapper>
        </>
);}

export default SponsorNewChildPopup;